import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FiscalYear } from 'app/internal/shared/models';

@Component({
  selector: 'sp-dashboard-past-display',
  templateUrl: './dashboard-past-display.component.html',
  styleUrls: ['./dashboard-past-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DashboardPastDisplayComponent {
  @Input() fiscalYear: FiscalYear;

}
